module.exports = __webpack_public_path__ + "img/伯才.dcf0cc44.svg";